(function() {
    'use strict';

    angular.module('swif.patrimoine')
        .controller('ContractTaskController', ContractTaskController)
        .directive('tablePatrimoineContractTasks', tablePatrimoineContractTasks);


    function ContractTaskController($scope, openstc, patrimoine, swif, swifOpenbaseCompanyService) {
    	'ngInject';
        console.log('init ContractTaskController');
        var serviceInter = openstc;
        var service = patrimoine.contract;

        swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {
            $scope.taskNotify = company.task_notify;
            if ($scope.model.notify === undefined){
                $scope.model._task.notify = company.task_notify_default_value;
            }
        });

        // for now, the model is an project.task object
        if (!$scope.model._task) { $scope.model._task = $scope.model; }
        $scope.advancedMode = $scope.model._task && $scope.model._task.site1 && $scope.model._task.site_ids ? true : false;
        $scope.getSitesFilters = function() {
            service.task.getSitesFilters(
                $scope.filters,
                $scope.model._task
            );
        };

        /*
         * @param taskDone: (Boolean) indicates the mode we are switching to
         * (true: we swtich to 'done mode', false: we switch to 'draft mode')
         * @notes: update the internal hash _siteControls
         *  and update the siteControls storage
         */
        $scope.switchSiteControlsCollection = function(taskDone) {
            if ($scope.model._task.id) {
                return;
            }
            var oldV = angular.copy($scope.model._task._siteControls);
            if (taskDone) {
                $scope.siteControls.draftTask = oldV;
                $scope.model._task._siteControls = $scope.siteControls.doneTask;
            } else {
                $scope.siteControls.doneTask = oldV;
                $scope.model._task._siteControls = $scope.siteControls.draftTask;
            }
        };

        $scope.initialize = function() {
            $scope.loading = service.recurrence.loading;
            // siteControls is used to store the actual value of siteControls,
            // as we have to switch between them when changing value of _state._done
            $scope.siteControls = {
                draftTask: [],
                doneTask: []
            };
            $scope.model._state = {
                done: false
            };
            $scope.model._surveys = [];
            // initilize filters for ui-select components
            $scope.filters = serviceInter.task.getFilters(
                $scope.model._task,
                undefined,
                true
            );
            $scope.getSitesFilters();
            var filter = {};
            var controlDefer;
            // if task already has some controls on database, initialize them
            if ($scope.model._task.id) {
                swif.data.addFilter(
                    filter,
                    'control_task_id',
                    '=',
                    $scope.model._task.id
                );
                controlDefer = swif.data.get(
                    'patrimoine_site_control',
                    undefined,
                    filter
                );
                // else, for new task, try to retrieve controls from its project
            } else if ($scope.model._task.project_id) {
                swif.data.addFilter(
                    filter,
                    'project_id',
                    '=',
                    $scope.model._task.project_id[0]
                );
                controlDefer = swif.data.get(
                    'patrimoine_site_control_tmpl',
                    undefined,
                    filter
                );
            }

            if (controlDefer) {
                controlDefer.then(function(data) {
                    // set the _index attribute to correctly react on site_ids updates
                    _.forEach(data, function(item) {
                        // delete id because its only a copy from project controls
                        delete item.id;
                        if (item.site_id) {
                            item._index = item.site_id[0];
                        }
                        if (item.equipment_id) {
                            item._index = item.equipment_id[0];
                        }
                    });
                    $scope.model._task._siteControls = data;
                });
            }

            $scope.updateSiteControls = service.updateSiteControls;

            $scope.$watchGroup(
                ['model._task.user_id', 'model._task.service_id'],
                function(newV, oldV) {
                    if (!angular.equals(newV, oldV)) {
                        $scope.filters = serviceInter.task.getFilters(
                            $scope.model._task,
                            undefined,
                            true
                        );
                    }
                }
            );
        };

        if ($scope.model._defer) {
            $scope.model._defer.then(function() {
                // @tocheck: does this 2nd callback called AFTER the first one
                // (defined on service ?)
                $scope.initialize();
            });
        } else {
            $scope.initialize();
        }

        /* According to newV, oldV and initial name value, update the name
          - if no name was filled, set a value
        */
        $scope.$watch('model._task.category_id', function(newV, oldV) {
            var newVal = newV ? newV[1] : '';
            var oldVal = oldV ? oldV[1] : '';
            var newString = $scope.model._task.name;
            if (!$scope.model._task.name) {
                newString = newVal;
            } else if (!angular.equals(newVal, oldVal) && oldVal === $scope.model._task.name) {
                newString = newVal;
            }
            $scope.model._task.name = newString;
        });

        /*
         * @param control: (Object) control to update the surveys
         * @param newV (Array of IDS): new property IDS to create surveys
         * @param newV (Array of IDS): old property IDS
         * @notes: When properties change:
         * - delete table rows for removed properties
         * - create a new table rows for new selected properties
         */
        $scope.updateControlSurveys = function(control, newV, oldV) {
            if (!angular.equals(newV, oldV)) {
                if (!control._surveys) {
                    control._surveys = [];
                }
                newV = newV || [];
                oldV = oldV || [];
                // first, compute the changes made on the field
                var removed_ids = _.intersection(oldV, _.xor(oldV, newV));
                var new_ids = _.intersection(newV, _.xor(oldV, newV));
                var newValues = [];
                // then, trash the removed items
                _.forEach(control._surveys, function(item) {
                    if (item._index && !_.contains(removed_ids, item._index)) {
                        newValues.push(item);
                    }
                });
                control._surveys = newValues;
                // finally, fetch the new items added, and insert them into the Array
                _.forEach(new_ids, function(new_id) {
                    var newObj = {};
                    newObj._index = new_id;
                    swif.data.get('patrimoine_property', new_id)
                        .then(function(data) {
                            newObj.site_property_id = [data.id, data.complete_name || data.name];
                            newObj.property_qty = data.qty;
                            newObj.property_last_survey_date = data.last_survey_date;
                            newObj.new_state = data.state;
                            newObj.notes = '';
                            newObj.done = false;
                            var surveysCopy = angular.copy(control._surveys);
                            surveysCopy.push(newObj);
                            control._surveys = surveysCopy;
                        });
                });
            }
        };

        $scope.$watchGroup(
            ['model._task.site_ids', 'model._task.site1'],
            function(newV, oldV) {
                if (!angular.equals(newV, oldV)) {
                    $scope.getSitesFilters();
                }
                /* @notes: on the following code, we assume that
                 * site_ids and site_id are not present on the same time
                 * to the user, because each task mode (draft or done) uses
                 * a different siteCOntrols collection (see switchSiteControlsCollection())
                 */

                // has site_ids been modified ?
                if (!angular.equals(newV[0], oldV[0])) {
                    $scope.model._task._siteControls = $scope.updateSiteControls(
                        $scope.model._task._siteControls,
                        newV[0],
                        oldV[0],
                        'patrimoine_site'
                    );
                }
                // has site1 been modified ?
                if (!angular.equals(newV[1], oldV[1])) {
                    var newSite = newV[1] ? [newV[1][0]] : [];
                    var oldSite = oldV[1] ? [oldV[1][0]] : [];
                    $scope.model._task._siteControls = $scope.updateSiteControls(
                        $scope.model._task._siteControls,
                        newSite,
                        oldSite,
                        'patrimoine_site'
                    );
                }
            }
        );
        $scope.$watch('model._task._state.done', function(newV, oldV) {
            if (newV !== oldV) {
                $scope.switchSiteControlsCollection(newV);
            }
        });

        $scope.$watch('model._task._siteControls', function(newV, oldV) {
            if ($scope.model._task._state && $scope.model._task._state.done) {
                if (!angular.equals(newV, oldV)) {
                    _.forEach(newV, function(control) {
                        // try to find the related oldV
                        var oldCtrl = _.find(oldV, function(item) {
                            return item._index === control._index;
                        }) || {};
                        $scope.updateControlSurveys(
                            control,
                            control.site_property_ids,
                            oldCtrl.site_property_ids
                        );
                    });
                }
            }
        }, true);
    }

    function tablePatrimoineContractTasks() {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: 'partials/patrimoine/contract_tasks_table_directive.html'
        };
    }


})();
